import { render, staticRenderFns } from "./SiteMessageBannerCarousel.vue?vue&type=template&id=a073f23e&scoped=true&lang=pug&"
import script from "./SiteMessageBannerCarousel.vue?vue&type=script&lang=js&"
export * from "./SiteMessageBannerCarousel.vue?vue&type=script&lang=js&"
import style0 from "./SiteMessageBannerCarousel.vue?vue&type=style&index=0&id=a073f23e&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a073f23e",
  null
  
)

export default component.exports